import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { firstValueFrom } from "rxjs";
import {
  TipificationReason,
  TipificationPayload,
  TipificationResponse,
} from "../models/tipification.model";
import { environment } from "../../../../environments/environment";
import { TenantUrlUtilService } from "@shared/services/tenant-url-util.service";

@Injectable({ providedIn: "root" })
export class TipificationService {
  private readonly http = inject(HttpClient);
  private readonly tenantUrlUtil = inject(TenantUrlUtilService);
  private readonly endpoint = environment.API_INTERACTIONS;

  async fetchReasons(queueId: string): Promise<TipificationReason[]> {
    const tenant = this.tenantUrlUtil.currentTenant() ?? "HPSA";
    const url = `${this.endpoint}/${tenant}/reason?queueId=${queueId}`;
    return firstValueFrom(this.http.get<TipificationReason[]>(url));
  }

  async createTipification(
    payload: TipificationPayload,
  ): Promise<TipificationResponse> {
    const tenant = this.tenantUrlUtil.currentTenant() ?? "HPSA";
    const url = `${this.endpoint}/${tenant}/create`;

    try {
      const response = await firstValueFrom(
        this.http.post<TipificationResponse>(url, payload, {
          observe: "response",
        }),
      );

      if (response.status === 200 || response.status === 201) {
        if (response.body) {
          return response.body;
        }
        return {} as TipificationResponse;
      }

      throw new Error(`Unexpected response status: ${response.status}`);
    } catch (error: any) {
      if (error.status === 200 || error.status === 201) {
        return error.error || ({} as TipificationResponse);
      }
      if (error.status) {
        throw new Error(
          `Tipification failed with status ${error.status}: ${error.message || "Unknown error"}`,
        );
      }
      throw error;
    }
  }
}
